import { get, post } from '../../tools/http';
import App from '../../main';

const service = 'profile';

export default {
    namespaced: true,
    state: {
        groupFiles: [],
        userFiles: [],
    },
    getters: {
        getGroupFiles: state => state.groupFiles,
        getUserFiles: state => state.userFiles,
    },
    mutations: {
        setGroupFiles: (state, data) => state.groupFiles = data,
        setUserFiles: (state, data) => state.userFiles = data,
    },
    actions: {
        fetchGroupFiles: async (ctx) => {
            let groupId = ctx.rootState.mentoring.groupId;
            if (!groupId) return;

            const response = await get(service, `file/group/${groupId}`);

            ctx.commit('setGroupFiles', response.files);
            return response.files;
        },
        fetchUserFiles: async (ctx) => {
            const response = await get(service, `file/self`);

            ctx.commit('setUserFiles', response.files);
            return response.files;
        },
        uploadFile: async (ctx, file) => {
            const name = file.name;

            try {
                const uploadResponse = await post(service, 'file/upload', { file:file, isPublic: true });

                const bindResponse = await ctx.dispatch('bindFile', {
                    fileId: uploadResponse.file.id,
                    group_id: null,
                    is_favorite: false,
                    name,
                });

                return {
                    upload: uploadResponse.file,
                    bind: bindResponse,
                };
            } catch (error) {
                return error;
            }

        },
        bindFile: async (ctx, data) => {
            const response = await post(service, 'file/bind', data, true);

            return response.userFile;
        },
        deleteFile: async (ctx, fileId) => {
            try {
                await get(service,`file/remove/${fileId}`);
                return 'success';
            } catch (error) {
                App.$noty.error(error.response.data.message);
                return error.response.data.status;
            }
        },
    },
};
